import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IOneRequestPayload {
    id: string
}

export interface ICreateState {
    status: string
    data: null
    errors: any
}

const initialState: ICreateState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const oneSlice = createSlice({
    name: 'hub/editList/one',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<IOneRequestPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const oneActions = oneSlice.actions
export default oneSlice.reducer
